import * as queries from '../graphql/queries';

export const stripBlock = (query, tagName) => {
  const startIdx = query.indexOf(`${tagName} {`);
  const startStr = query.substr(0, startIdx);
  const endIdx = query.indexOf('}', startIdx);
  const endStr = query.substr(endIdx + 1, queries.byAccountType.length);
  return `${startStr}${endStr}`;
}
